import { useTranslation } from 'react-i18next'

export default function HomePage() {
  const { t } = useTranslation()
  
  return (
    <div className="max-w-4xl mx-auto py-20 px-6 text-center">
      <h1 className="text-5xl font-bold mb-6 text-gray-900">
        {t('home.title')}
      </h1>
      <p className="text-xl text-gray-600 mb-10">
        {t('home.subtitle')}
      </p>
      <a
        href="/search"
        className="inline-block bg-primary-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-primary-700 transition"
      >
        {t('home.startComparing')}
      </a>
    </div>
  )
}
